import React, { useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';
import VideoPlayerModal from 'components/VideoPlayerModal';

import { useToggle } from '@common/helpers/useToggle';

type InstallPromptEvent = Event & {
	prompt: () => Promise<void>;
	userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
};

function NonIosInstallBanner() {
	const [installPrompt, setInstallPrompt] = useState<InstallPromptEvent | null>(null);
	const controls = useToggle();
	const hideInstallGuide =
		typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('isTis');

	const openVideo = () => {
		controls.onOpen({
			videoUrl: 'https://storage.campus.key.study/videos/9415256784+android+v1.mp4',
			title: 'Installation guide',
		});
	};
	useEffect(() => {
		if (typeof window === 'undefined') return undefined;
		const handleBeforeInstallPrompt = (event: Event) => {
			event.preventDefault();
			setInstallPrompt(event as InstallPromptEvent);
		};
		window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
		return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
	}, []);

	const handleInstallClick = async () => {
		if (!installPrompt) return;
		try {
			await installPrompt.prompt();
			await installPrompt.userChoice;
		} finally {
			setInstallPrompt(null);
		}
	};

	return installPrompt ? (
		<>
			<Typography
				onClick={handleInstallClick}
				sx={{ fontSize: '21px', textAlign: 'center' }}
				variant="body1"
			>
				<span style={{ fontWeight: 600, cursor: 'pointer', color: '#2d6cdf' }}>Tap here</span> to
				continue installing campus
			</Typography>
			{!hideInstallGuide && (
				<Box
					sx={{
						position: 'fixed',
						bottom: '30px',
						display: 'flex',
						justifyContent: 'center',
						width: '100%',
						padding: '0 16px',
					}}
				>
					<Typography variant="subtitle1">
						<Box onClick={openVideo} component="span" sx={{ cursor: 'pointer', color: '#2d6cdf' }}>
							Watch&nbsp;
						</Box>
						installation guide
					</Typography>
				</Box>
			)}
			{controls.isOpen && <VideoPlayerModal controls={controls} />}
		</>
	) : null;
}

export default NonIosInstallBanner;
